import React, { Fragment } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import List from './List';
import Edit from './Edit';

export default withRouter(({ match }) => (
	<Fragment>
		<Switch>
			<Route path={`${match.url}/:id`} exact component={Edit} />
			<Route path={`${match.url}`} component={List} />
		</Switch>
	</Fragment>
));



// WEBPACK FOOTER //
// ./src/routes/Admin/Practices/index.js